import React, { PropTypes } from 'react';
import { Editor, EditorState, RichUtils } from 'draft-js';
import emptyFunction from 'fbjs/lib/emptyFunction';

const MAX_LIST_DEPTH = 2;

class RichTextEditorSingle extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    editorState: PropTypes.instanceOf(EditorState).isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    rows: PropTypes.number.isRequired
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  static defaultProps = {
    disabled: false,
    rows: 8,
    onBlur: emptyFunction
  };

  getStyle() {
    let {textField} = this.context.muiTheme;
    let { rows } = this.props;
    rows -= 2;

    return {
      editor: {
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: '1rem',
        color: textField.textColor,
        fontSize: textField.textSize,
        height: `${rows}rem`
      }
    };
  }

  render() {
    let {
      id,
      disabled,
      editorState,
      onBlur } = this.props;
    let style = this.getStyle();

    return (
      <div style={style.editor} onClick={this.focus}>
        <Editor
          id={id}
          readOnly={disabled}
          onBlur={onBlur}
          editorState={editorState}
          handleKeyCommand={this.handleKeyCommand}
          onChange={this.onChange}
          onTab={this.onTab}
          ref="editor"
        />
      </div>
    );
  }

  handleKeyCommand = (command) => {
    const {editorState} = this.props;
    let newEditorState = RichUtils.handleKeyCommand(editorState, command);
    if (newEditorState) {
      this._onChange(newEditorState);
      return true;
    } else {
      return false;
    }
  };

  focus = () => this.refs.editor.focus();

  onChange = (editorState) => this.props.onChange(editorState);

  onTab = (event: Object) => {
    let { editorState } = this.props;
    let newEditorState = RichUtils.onTab(event, editorState, MAX_LIST_DEPTH);
    if (newEditorState !== editorState) {
      this.onChange(newEditorState);
    }
  };

}

export default RichTextEditorSingle;




// WEBPACK FOOTER //
// ./src/components/form/RichEditor/RichTextEditorSingle.jsx